import React, { useState } from 'react'
import { BASE_PATH_PORTAL } from 'constants/general'
import './style.sass'

export default function BoxPoliticasSears() {
    const [menuView, setMenuView] = useState(false);

    const toggleClass = () => {
        setMenuView(!menuView);
    };

    return (
        <div className="boxServicioCliente">
            <p onClick={toggleClass} className={menuView ? 'active' : null}>Servicio al Cliente</p>
            <ul>
                <li><a href="http://facturacionelectronica.claroshop.com/" target="_blank" rel="noopener noreferrer">Facturación electrónica</a></li>
                <li><a href={`${BASE_PATH_PORTAL}/c/Claroshop/claroPromo/index.html`} >Promociones diversas vigentes</a></li>
                {/* https://www.claroshop.com/c/Claroshop/claroPromo/index.html {`${BASE_PATH_PORTAL}/c/claroPromo/`} */}
                <li><a href={`${BASE_PATH_PORTAL}/formas-pago/`} >Formas de pago</a></li>
                <li><a href={`${BASE_PATH_PORTAL}/politica-devoluciones/`} >Cambios y devoluciones</a></li>
                <li><a href={`${BASE_PATH_PORTAL}/l/faqs/`} >Preguntas frecuentes</a></li>
            </ul>
        </div>
    )
}
;